var _style, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    height: "100%",
    width: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st1{fill:#ACACAC;}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dark_Blue"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Annotations"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M569.3,442.6L842.5,125h-64.7L540.5,400.7L351.1,125H132.5l286.5,417L132.5,875h64.7l250.5-291.2L647.9,875  h218.5L569.3,442.6L569.3,442.6z M480.6,545.6l-29-41.5l-231-330.4h99.4l186.4,266.6l29,41.5l242.3,346.6h-99.4L480.6,545.6  L480.6,545.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.fff86461d19ac90d688c84c2fa9e9cc8.svg";
export { ForwardRef as ReactComponent };